import React from 'react';
import { injectIntl } from 'react-intl';
import TransitionLink from 'components/transition-link/transition-link';
import classNames from "classnames";
import Logo from 'components/logos/logo';
import Text from 'components/text/text';
import LocalePicker from 'components/locale-picker/locale-picker';
import messages from './messages';
import localeMessages from 'components/locale-picker/messages';

class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.setupHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setupHandlers() {
    this.onLocaleClick = this.handleLocaleClick.bind(this);
  }

  /**
   * Shows locale selector overlay
   *
   * @method  handleLocaleClick
   *
   */
  handleLocaleClick() {
    const dialogView = <LocalePicker onLocaleChange={this.props.onLocaleChange} />

    this.props.toggleDialog(dialogView, true);
  }

  render() {
    const { intl, light, dark } = this.props;
    const footerClasses = classNames(
      'footer',
      {
        'footer_light': light,
        'footer_dark': dark
      }
    );

    return (
      <footer className={footerClasses} role="contentinfo">
        <div className="footer-inner">
          <div className="footerLogo">
            <Logo
              fill="DarkGray"
              logoType="default"
              height="18"
              width="47"
            />
          </div>
          <div className="footerInfo">
            <div className="footerLinks">
              <a className="footerLinks-link" onClick={this.onLocaleClick}>
                <Text color="RegularGray" justify="Center" type="sm" weight="light">
                  {intl.formatMessage(localeMessages[`label_${intl.locale}`])}
                </Text>
              </a>

              <TransitionLink
                className="footerLinks-link"
                to="/terms"
              >
                <Text
                  className="mix-txt_capitalize"
                  color="RegularGray"
                  justify="Center"
                  type="sm"
                  weight="light"
                >
                  {intl.formatMessage(messages.terms_link_label)}
                </Text>
              </TransitionLink>
              <TransitionLink
                className="footerLinks-link"
                to="/privacy-policy"
              >
                <Text
                  className="mix-txt_capitalize"
                  color="RegularGray"
                  justify="Center"
                  type="sm"
                  weight="light"
                >
                  {intl.formatMessage(messages.privacy_link_label)}
                </Text>
              </TransitionLink>
            </div>
            <div className="footerCopyright">
              <Text
                className="mix-txt_capitalize"
                color="RegularGray"
                justify="Center"
                type="sm"
                weight="light"
              >
                {`\u00A9${GLOBALS.CURRENT_YEAR} Retul`}
              </Text>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/client/components/footer/footer.jsx